const STORAGE_KEY = 'ch:notifications:seen:v1';
const SEEN_EVENT = 'ch:notifications:seen';

class CHNotificationsUnread extends HTMLElement {
  #dialog;
  #seen = {};

  connectedCallback() {
    // A theme editor section can connect before its sibling drawer is inserted.
    queueMicrotask(() => {
      if (!this.isConnected) return;
      this.#dialog = document.getElementById(this.dataset.dialogId);
      if (!this.#dialog) return;
      this.#readSeen();
      this.#dialog.addEventListener('dialog:open', this.#markSeen);
      window.addEventListener('storage', this.#onStorage);
      window.addEventListener(SEEN_EVENT, this.#onSeen);
      if (this.#dialog.querySelector('dialog')?.open) this.#markSeen();
      else this.#render();
    });
  }

  disconnectedCallback() {
    this.#dialog?.removeEventListener('dialog:open', this.#markSeen);
    window.removeEventListener('storage', this.#onStorage);
    window.removeEventListener(SEEN_EVENT, this.#onSeen);
  }

  #records() {
    return Array.from(this.#dialog.querySelectorAll('[data-ch-notification-id]'))
      .map((item) => [item.dataset.chNotificationId, item.dataset.chNotificationRevision])
      .filter(([id, revision]) => id && revision);
  }

  #readSeen() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      this.#seen = stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
    } catch {
      // Keep the in-memory state when storage is unavailable.
    }
  }

  #render() {
    const records = new Map(this.#records());
    const count = Array.from(records).filter(([id, revision]) => this.#seen[id] !== revision).length;
    this.classList.toggle('visually-hidden', count === 0);
    this.querySelector('[data-ch-notifications-count]').textContent = count > 99 ? '99+' : String(count);
    this.closest('button')?.setAttribute('aria-label', count ? `Notifications, ${count} unread` : 'Notifications');
  }

  #markSeen = () => {
    this.#seen = Object.fromEntries(this.#records());
    this.#render();
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.#seen));
    } catch {
      // The drawer still clears the badge for this visit.
    }
    window.dispatchEvent(new CustomEvent(SEEN_EVENT, { detail: this.#seen }));
  };

  #onStorage = (event) => {
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    this.#readSeen();
    this.#render();
  };

  #onSeen = (event) => {
    this.#seen = event.detail;
    this.#render();
  };
}

if (!customElements.get('ch-notifications-unread')) {
  customElements.define('ch-notifications-unread', CHNotificationsUnread);
}
